import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import HeaderBackgroundBanner from 'components/HeaderBackgroundBanner';
import { contactPersonelFormUrl } from 'constants/forms';

const KvkkPolicy = ({ t }) => {
  const styles = {
    list: {
      listStyleType: 'disc',
    },
    listItem: {
      fontSize: 'inherit',
      marginBottom: '0.2rem',
    },
  };

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('agreements'),
      url: '/',
    },
    {
      label: t('kvkkPolicy'),
      url: '/agreements/kvkk-policy',
    },
  ];

  return (
    <main className="has-header">
      <HeaderBackgroundBanner />

      <div className="container">
        <div className="mt-4 mb-4 mt-lg-3 mb-lg-3">
          <Breadcrumb links={breadcrumbs} />
        </div>

        <div className="mx-auto mt-4 mb-5" style={{ maxWidth: '800px' }}>
          <h1 className="mb-3">
            iyiMakina Bilgi Teknolojileri ve Ticaret Anonim Şirketi Kişisel Verilerin Korunması Ve İşlenmesi Politikasi
          </h1>

          <h4 className="mb-2">İçindekiler</h4>
          <h6 className="ml-2">1. Giriş</h6>
          <h6 className="ml-2">2. Tanımlar</h6>
          <h6 className="ml-2">3. Kişisel Verilerin İşlenme Amaçları, Veri Sahipleri ve Veri Kategorileri</h6>
          <h6 className="ml-2">4. Kişisel Verileri Toplama Yöntemlerimiz</h6>
          <h6 className="ml-2">5. İşlemeye Yönelik Hukuki Gerekçeler</h6>
          <h6 className="ml-2">6. Kişisel Verilerin Aktarılması</h6>
          <h6 className="ml-2">7. Veri Sahiplerinin Hakları</h6>
          <h6 className="ml-2">8. Kişisel Verilerin Silinmesi, İmha Edilmesi, Anonim Hale Gelmesi</h6>

          <h5 className="mt-4">1. Giriş</h5>
          <p>
            İşbu Kişisel Verilerin İşlenmesi ve Korunması Aydınlatma Metni (“Aydınlatma Metni”),  6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”)
            uyarınca kişisel verilerinizin toplanması, işlenmesi, aktarılması, korunması ve Kanun kapsamındaki yükümlülüklerini belirlemek ve sizleri bilgilendirmek amacıyla hazırlanmıştır.
          </p>
          <p>
            Kişisel verilerinizin işlenmesine ilişkin olarak, iyiMakina Bilgi Teknolojileri ve Ticaret A.Ş. (“Şirket”) Veri Sorumlusu sıfatına sahiptir ve kişisel
            verileriniz Şirket tarafından aşağıda açıklanan şart ve sınırlara bağlı olarak ve her zaman Kanun’a uygun olarak işlenmektedir.
          </p>

          <h5 className="mt-4">2. Tanımlar</h5>
          <table className="table table-responsive">
            <tr>
              <td className="font-weight-bold">Açık Rıza</td>
              <td>Belirli bir konuya ilişkin, bilgilendirilmeye dayanan ve özgür iradeyle açıklanan rıza.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Anonim Hale Getirme</td>
              <td>Kişisel verinin, başka verilerle eşleştirilerek dahi hiçbir surette kimliği belirli veya belirlenebilir bir gerçek kişiyle ilişkilendirilemeyecek hale getirilmesi.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Çalışan</td>
              <td>Şirket çalışanı olan gerçek kişiler.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Çalışan Adayı</td>
              <td>Şirket çalışanı olmayan ancak çeşitli yöntemlerle Şirket çalışan adayı statüsünde olan gerçek kişiler.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Kişisel Sağlık Verisi</td>
              <td>Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü sağlık bilgisi.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Kişisel Veri</td>
              <td>Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Kişisel Verilerin İşlenmesi</td>
              <td>Kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde edilebilir hale getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler üzerinde gerçekleştirilen her türlü işlem.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Kanun</td>
              <td>7 Nisan 2016 tarihli ve 29677 sayılı Resmi Gazete’de yayımlanan 6698 sayılı Kişisel Verilerin Korunması Kanunu.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Özel Nitelikli Kişisel Veri</td>
              <td>Irk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep veya diğer inançlar, kılık kıyafet, dernek vakıf ya da sendika üyeliği, sağlık, cinsel hayat, ceza mahkumiyeti ve güvenlik tedbirleriyle ilgili veriler ile biyometrik ve genetik veriler.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Politika</td>
              <td>Çelik Motor Ticaret Anonim Şirketi Kişisel Verilerin İşlenmesi ve Korunması Politikası.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Şirket/Çelik Motor</td>
              <td>Çelik Motor Ticaret Anonim Şirketi.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">İş Ortakları</td>
              <td>Şirket’in ticari faaliyetleri çerçevesinde sözleşmesel ilişkiler kapsamında ortaklık kurduğu kişiler.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Veri Sahibi</td>
              <td>Kişisel verisi işlenen gerçek kişi.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Veri İşleyen</td>
              <td>Veri sorumlusunun verdiği yetkiye dayanarak onun adına kişisel veri işleyen gerçek ve tüzel kişidir.</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Veri Sorumlusu</td>
              <td>Kişisel verilerin işlenme amaçlarını ve vasıtalarını belirleyen, verilerin sistematik bir şekilde tutulduğu yeri yöneten kişidir.</td>
            </tr>
          </table>

          <h5 className="mt-4">3. Kişisel Verilerin İşlenme Amaçları, Veri Sahipleri ve Veri Kategorileri</h5>
          <h6>3.1. Veri Sahipleri</h6>
          <p>Veri sahipleri, Şirket personeli haricinde Şirket’in kişisel verilerini işlediği tüm gerçek kişilerdir. Genel olarak veri sahipleri aşağıdaki şekilde sınıflandırılmaktadır: </p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Müşteri</li>
            <li style={styles.listItem}>Potansiyel Müşteri</li>
            <li style={styles.listItem}>Ziyaretçi</li>
            <li style={styles.listItem}>Çalışan Adayı</li>
            <li style={styles.listItem}>Üçüncü Kişiler</li>
          </ol>
          <p>Veri sahibi sınıflandırmaları genel bilgilendirme gayesiyle belirtilmiştir. Veri sahibinin bu sınıflardan birine dahil olmaması, Kanun’da belirtildiği üzere veri sahibi niteliğini ortadan kaldırmamaktadır. </p>
          <h6>3.2. Veri Sahipleri</h6>
          <p>
            Şirket olarak işlediğimiz kişisel verilerin gizliliği bizler için önem arz etmektedir. Kanunu’ndaki genel ilke ve işleme koşullarına uygun olarak kişisel verileriniz toplanmakta ve işlenmektedir.
            Bu bağlamda kişisel verilerinizin işlenmesi aşağıdaki amaçlar ile sınırlı kalacaktır:
          </p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Bilgi güvenliği süreçlerinin planlanması, denetimi ve icrası</li>
            <li style={styles.listItem}>Bilgi teknolojileri altyapısının oluşturulması ve yönetilmesi</li>
            <li style={styles.listItem}>Çalışanların bilgi sistemlerine erişim yetkilerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Etkinlik yönetimi</li>
            <li style={styles.listItem}>Finans ve muhasebe işlerinin takibi</li>
            <li style={styles.listItem}>İş faaliyetlerinin etkinlik/verimlilik ve yerindelik analizlerinin gerçekleştirilmesi faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>İş faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>İş ortakları ve tedarikçilerin bilgi sistemlerine erişim yetkilerinin planlanması ve icrası</li>
            <li style={styles.listItem}>İş sürekliliğinin sağlanması faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Kurumsal iletişim faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Kurumsal sürdürülebilirlik faaliyetlerin planlanması ve icrası</li>
            <li style={styles.listItem}>Kurumsal yönetim faaliyetlerin planlanması ve icrası</li>
            <li style={styles.listItem}>Lojistik faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Üretim ve operasyon süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Yapı ve inşaat işlerinin planlanması ve takibi</li>
            <li style={styles.listItem}>Acil durum yönetimi süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>İş sağlığı ve güvenliği süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>İştiraklerle olan ilişkilerin yönetimi ve denetimi</li>
            <li style={styles.listItem}>Hukuk işlerinin takibi</li>
            <li style={styles.listItem}>Grup şirketleri bilişim teknolojileri ve operasyonel denetim çalışmaları</li>
            <li style={styles.listItem}>Yetkili kuruluşlara mevzuattan kaynaklı bilgi verilmesi</li>
            <li style={styles.listItem}>Ziyaretçi kayıtlarının oluşturulması ve takibi</li>
            <li style={styles.listItem}>Şirketin üretim ve operasyonel risk süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Şirketler ve ortaklık hukuku işlemlerinin gerçekleştirilmesi</li>
            <li style={styles.listItem}>Şirket operasyonlarının güvenliğinin temini</li>
            <li style={styles.listItem}>Şirket yerleşkeleri ve tesislerinin güvenliğinin temini</li>
            <li style={styles.listItem}>Şirketin finansal risk süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Şirket demirbaşlarının ve kaynaklarının güvenliğinin temini</li>
            <li style={styles.listItem}>Şirket denetim faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Şirket faaliyetlerinin şirket prosedürleri ve ilgili mevzuata uygun olarak yürütülmesinin temini için gerekli operasyonel faaliyetlerin planlanması ve icrası</li>
            <li style={styles.listItem}>Verilerin doğru ve güncel olmasının sağlanması</li>
            <li style={styles.listItem}>Satış sonrası destek hizmetleri aktivitelerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Ürün ve hizmetlerin satış süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Sözleşme süreçlerinin ve hukuki taleplerin takibi</li>
            <li style={styles.listItem}>Müşteri ilişkileri yönetimi süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Bankacılık işlemleri</li>
            <li style={styles.listItem}>İş ortakları ve/veya tedarikçilerle olan ilişkilerin yönetimi</li>
            <li style={styles.listItem}>Şirket dışı eğitim faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Stratejik planlama faaliyetlerinin icrası</li>
            <li style={styles.listItem}>Şirketin sunduğu ürün ve hizmetlere bağlılık oluşturulması ve arttırılması süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Ürün ve hizmetlerin satış ve pazarlaması için pazar araştırması faaliyetlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Ürün ve hizmetlerin pazarlama süreçlerinin planlanması ve icrası</li>
            <li style={styles.listItem}>Müşteri memnuniyeti aktivitelerinin planlanması ve icrası</li>
          </ol>
          <h6 className="mt-2">3.3. Kişisel Veri Kategorileri</h6>
          <p>Aşağıda sınıflandırılmış kişisel verileriniz, Kanun’da ve ilgili mevzuatta yer alan kişisel veri işleme şartlarına uygun olarak işlenir:</p>
          <p>
            <span className="font-weight-bold">Kimlik Bilgisi: </span>
            TCKN, Pasaport No, isimı, soyisim, imza, fotoğraf, doğum yeri, doğum tarihi, yaşı, nüfus cüzdanı seri numarası, sürücü belgesi fotokopileri.
          </p>
          <p>
            <span className="font-weight-bold">İletişim Bilgisi: </span>
            E-posta, telefon numarası, cep telefonu, sosyal medya hesapları.
          </p>
          <p>
            <span className="font-weight-bold">Müşteri Bilgisi: </span>
            Şirket’in yürüttüğü ticari faaliyetler ve operasyonlar neticesinde ilgili kişi hakkında elde edilen ve üretilen bilgiler
          </p>
          <p>
            <span className="font-weight-bold">Aile Bireyleri ve Yakın Bilgisi: </span>
            Sunduğumuz ürün ve hizmetlerle ilgili veya Şirketin ve veri sahibinin hukuki menfaatlerini korumak amacıyla işlenen kişisel veri sahibinin aile bireyleri ve yakınları hakkındaki bilgiler
          </p>
          <p>
            <span className="font-weight-bold">Müşteri İşlem Bilgisi: </span>
            Çağrı merkezi kayıtları, fatura, senet, çek bilgileri, gişe dekontlarındaki bilgiler, müşteri talep ve şikayet bilgileri
          </p>
          <p>
            <span className="font-weight-bold">Fiziksel Mekân Güvenlik Bilgisi: </span>
            Ziyaretçilerin giriş çıkış kayıt bilgileri, CCTV kamera kayıtları
          </p>
          <p>
            <span className="font-weight-bold">İşlem Güvenliği Bilgisi: </span>
            Log in credential bilgileri, parola bilgileri, IP adresi bilgileri
          </p>
          <p>
            <span className="font-weight-bold">Finansal Bilgi: </span>
            Şirketin veri sahibi ile kurmuş olduğu ilişkiye bağlı olarak oluşan her çeşit finansal sonucu gösteren bilgi, belge ve kayıtlara ilişkin işlenen kişisel veriler
          </p>
          <p>
            <span className="font-weight-bold">Çalışan Adayı Bilgisi: </span>
            CV’ler, özgeçmiş bilgileri, iş başvuru formu, kurs, sertifika bilgileri ve diploma bilgileri, meslek içi eğitim bilgileri, iş mülakatlarında ilettiğiniz geçmiş eğitim ve meslek bilgileri, sertifikalar, transkript bilgileri, sahip olunan referans bilgileri.
          </p>
          <p>
            <span className="font-weight-bold">Hukuki İşlem ve Uyum Bilgisi: </span>
            Şirket’in haklarının tespiti, takibi ve borçlarının ifası ile kanuni yükümlülüklerinin ve Şirket’in politikalarına uyum kapsamında işlenen kişisel veriler
          </p>
          <p>
            <span className="font-weight-bold">Denetim ve Teftiş Bilgisi: </span>
            Şirketimizin kanuni yükümlülükleri ve şirket politikalarına uyumu kapsamında işlenen kişisel veriler
          </p>
          <p>
            <span className="font-weight-bold">Pazarlama Bilgisi: </span>
            Şirket’in sunduğu ürün ve hizmetlerin kişisel veri sahibinin kullanım alışkanlıkları, beğenisi ve ihtiyaçları doğrultusunda özelleştirilerek pazarlamasının yapılmasına yönelik işlenen kişisel veriler ve bu işleme sonuçları neticesinde yaratılan rapor ve değerlendirmeler.
          </p>
          <p>
            <span className="font-weight-bold">Talep/Şikâyet Yönetimi Bilgisi: </span>
            Her türlü talep/şikâyetin alınması ve değerlendirilmesi adına toplanan kişisel veriler
          </p>
          <p>
            <span className="font-weight-bold">İtibar Yönetimi Bilgisi: </span>
            Şirket’in ticari vb. itibarlarını korumak amacıyla toplanan bilgiler ve bunlara uygun oluşturulan evalüasyon raporları ile alınan aksiyonlarla ilgili bilgiler
          </p>
          <p>
            <span className="font-weight-bold">Olay Yönetimi Bilgisi: </span>
            Şirketimizin ticari hak ve menfaatleri ile müşterilerimizin hak ve menfaatlerini korumak maksatlı gelişen olaylara karşı gerekli hukuki, teknik ve idari tedbirlerin alınmasına yönelik olarak işlenen kişisel veriler
          </p>

          <h5 className="mt-4">4. Kişisel Verileri Toplama Yöntemlerimiz</h5>
          <p>Şirket kişisel verilerinizi aşağıda sıralanan kanallar üzerinden toplamaktadır:</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>E-posta</li>
            <li style={styles.listItem}>SMS</li>
            <li style={styles.listItem}>Kartvizitler</li>
            <li style={styles.listItem}>Fiziki ve elektronik formlar</li>
            <li style={styles.listItem}>İnternet sitemiz</li>
            <li style={styles.listItem}>Sitede kullanılan çerezler</li>
            <li style={styles.listItem}>Uzaktan erişim sağlayan platformlar</li>
            <li style={styles.listItem}>Posta,kargo ya da kurye hizmetleri</li>
            <li style={styles.listItem}>Yüz yüze görüşmeler</li>
            <li style={styles.listItem}>Diğer fiziki ve elektronik ortamlar.</li>
          </ol>

          <h5 className="mt-4">5. İşlemeye Yönelik Hukuki Gerekçeler</h5>
          <p>Kişisel verilerinizi aşağıdaki hukuki sebeplere dayalı olarak işlemekteyiz:</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>KVKK madde 5/1 uyarınca kişisel verilerinizi işlemek için açık rızanızı aldığımız haller.</li>
            <li style={styles.listItem}>KVKK madde 5/2(a) uyarınca, kanunlarda açıkça öngörülmesi.</li>
            <li style={styles.listItem}>KVKK madde 5/2(c) uyarınca, bir sözleşmenin kurulması veya ifası için kişisel verilerinizin gerekli olması. Örneğin, kullanıcılarımızın Şirket’in uygulamalarını kullanmalarının sağlanması.</li>
            <li style={styles.listItem}>KVKK madde 5/2(ç) uyarınca, Şirket’in hukuki yükümlülüğünü yerine getirmesi. Örneğin,Şirket’in internet erişimi sağladığı kişilerin erişim kayıtlarını 5651 sayılı Kanun uyarınca loglaması ve talep üzerine ilgili idareye iletmesi.</li>
            <li style={styles.listItem}>KVKK madde 5/2(e) uyarınca, Şirket’in kendi hakkını tesis etmesi, kullanması ve koruması. Olası bir uyuşmazlık veya davada Şirket’in kendini savunabilmesi amacıyla sözleşme ilişkisinin sona ermesinden itibaren kişisel verileri dava zamanaşımı süresi boyunca saklaması.</li>
            <li style={styles.listItem}>KVKK madde 5/2(f) uyarınca, Şirket’in meşru menfaati için gerekli olması.</li>
          </ol>

          <h5 className="mt-4">6. Kişisel Verilerin Aktarılması</h5>
          <p>Şirket, kişisel verilerinizi  Kanun’un 8. ve 9. maddelerinde belirtilen şartlara ve Kişisel Verileri Koruma Kurulu’nun belirlediği ilave düzenlemelere uygun olarak, yurt içinde veya yurt dışında Bölüm 2.2.’de belirtilen amaçlarımız doğrultusunda,</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Şirket’in ticari faaliyetlerini gerçekleştirirken iş ortaklığında bulunduğu taraflara</li>
            <li style={styles.listItem}>Şirket’ten aldığı yönergeler doğrultusunda ve Şirket ile yaptığı sözleşmeyi temel alarak Şirket’in ticari faaliyetlerini yürütmesine yönelik hizmet sunan taraflara</li>
            <li style={styles.listItem}>Şirket’in iştiraki olan şirketlere</li>
            <li style={styles.listItem}>Hukuken Şirket’ten bilgi ve belge almaya yetkili kamu kurum ve kuruluşlara</li>
            <li style={styles.listItem}>Hukuken Şirket’den bilgi ve belge almaya yetkili özel hukuk kişilere aktarabileceğiz.</li>
          </ol>
          <p className="mt-3 mb-1">Kişisel verileriniz aşağıdaki şartlardan birinin sağlanması halinde yurt dışındaki üçüncü kişiler ile paylaşabilir:</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Yurt dışına aktarma için kişinin açık rızası olması dahilinde</li>
            <li style={styles.listItem}>Kişinin açık rızası olmadığında, Kanun’un 5. ve 6. maddesindeki veri işleme şartlarından en az birinin varlığı halinde ve veri işleme şartlarına ilişkin temel ilkelere uymak şartıyla</li>
            <li style={styles.listItem}>Aktarımın yapılacağı ülkenin Kişisel Verileri Koruma Kurulu tarafından yeterli korumanın bulunmadığı beyanı halinde kişisel verilerin aktarılacağı taraf ile beraber yeterli bir korumayı yazılı olarak taahhüt etmesi ve Kişisel Verileri Koruma Kurulu’nun bu taahhüdü onaylaması halinde.</li>
          </ol>

          <h5 className="mt-4">7. Veri Sahiplerinin Hakları</h5>
          <p>
            Veri Sahibi olarak, Kanun’un 11. maddesi uyarınca kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:
          </p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li style={styles.listItem}>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
            <li style={styles.listItem}>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li style={styles.listItem}>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
            <li style={styles.listItem}>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
            <li style={styles.listItem}>6698 sayılı Kanunu ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin, kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
            <li style={styles.listItem}>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
            <li style={styles.listItem}>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde bu zararın giderilmesini talep etme.</li>
          </ol>
          <p className="mt-2">
            Bu haklarınız için taleplerinizi internet sitemizdeki
            {' '}
            <a href={contactPersonelFormUrl} target="_blank" rel="noreferrer">İlgili Kişi Formu</a>
            {' '}
            üzerinden gönderebilirsiniz. Başvurunuz ücretsiz olarak yerine getirilecektir.
            Ancak talep edilen işlemin ayrıca bir maliyeti beraberinde getirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücretler başvurandan talep edilecektir. Başvurularınıza  mümkün olan en kısa sürede ve en geç otuz gün içinde yazılı veya elektronik ortamdan geri dönüş sağlanacaktır.
            Bununla birlikte Şirket gerekli bulduğu vakalarda talebin daha iyi anlaşılabilmesi için daha fazla bilgi isteyebilmektedir. Talebinizin reddedilmesi halinde, başvurunuza gerekçeleriyle beraber geri dönülecektir.
          </p>

          <h5 className="mt-4">8. Kişisel Verilerin Silinmesi, İmha Edilmesi, Anonim Hale Gelmesi</h5>
          <p>Kanuna uygun olarak işlenmiş olmasına rağmen, Kanun’un 7. maddesi gereğince işlenmesini gerektiren gerekçelerin ortadan kalkması hâlinde veya veri sahibinin talebi üzerine Şirket, kişisel verileri Kişisel Verileri Koruma Kurumu tarafından yayımlanan rehberlere uyarak siler, imha eder veya anonim hâle getirir.</p>
        </div>
      </div>
    </main>
  );
};

KvkkPolicy.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async ({ req }) => {
  const { t } = req;

  return {
    props: {
      headTitle: t('kvkkPolicy'),
    },
  };
};

KvkkPolicy.Layout = Layout;

export default withTranslation('common')(KvkkPolicy);
